<template>
  <div style="display: inline-block" class="flex-grow-1">
    <v-btn
        v-if="order.state != 'DELIVERED'"
        color="indigo white--text"
        x-small fab
        @click="next"
        :disabled="order.delivery.mode === 'DELIVERY' && order.state === 'READY' && !order.deliveryUser"
    >
      <v-icon>double_arrow</v-icon>
    </v-btn>
  </div>
</template>

<script>
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import {ORDER_STATES, READY} from "@/modules/delivery/constants/OrderStates";
import {TAKE_AWAY, SALON} from "@/modules/delivery/constants/OrderDelivery";

export default {
  name: "OrderNextFlowState",
  props: {
    order: {type: Object},
  },
  data() {
    return {
      user: null,
      loading: false
    }
  },
  computed: {
    getNextStep() {
      let index = ORDER_STATES.findIndex(state => state === this.order.state)
      //Skip "ON_THE_WAY when is TAKE_AWAY or SALON
      if ([TAKE_AWAY, SALON].includes(this.order.delivery.mode) && this.order.state === READY) {
        return ORDER_STATES[index + 2]
        //Next STEP
      } else if (ORDER_STATES.length > (index + 1)) {
        return ORDER_STATES[index + 1]
      }

      return this.order.state
    }
  },
  methods: {

    async next() {
      try {
        this.loading = true

        const nextStep = this.getNextStep
        await this.updateOrderState(nextStep)
        this.order.state = nextStep

        this.$emit("orderUpdated", this.order)

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async updateOrderState(state) {
      return await OrderProvider.updateOrderState({id: this.order.id, state: state})
    },

  }
}
</script>

<style scoped>

</style>
